/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { ClientPortalUser, User } from '../../data/types';
import { signOut } from './authReducer';

export type UserState = {
    users: User[],
    authenticatedUser?: ClientPortalUser;
}

export const useUserState = () => {
    const userState = useSelector((state: RootState | any) => state.users as UserState);
    return userState;
}

// Define the initial state using that type
const initialState: UserState = {
    users: [],
}

export const userSlice = createSlice({
    name: 'users',
    initialState: initialState,
    reducers: {
        setAuthenticatedUserAction: (state, action: PayloadAction<ClientPortalUser | undefined>) => {
            state.authenticatedUser = action.payload;
            state.users = [];
        },
        setUsersAction: (state, action: PayloadAction<User[]>) => {
            state.users = action.payload;
        },
        addOrReplaceUserAction: (state, action: PayloadAction<User>) => {
            const existingIndex = state.users.findIndex((user: User) => !!user && (user.userId === action.payload.userId || user.username === action.payload.username));
            if (existingIndex >= 0) {
                state.users[existingIndex] = action.payload;
            } else {
                state.users = [...state.users, action.payload];
            }
        },        
        deleteUserAction: (state, action: PayloadAction<string>) => {
            state.users = state.users.filter((x) => x.userId !== action.payload && x.username !== action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(signOut, () => initialState);
    },
})

export const { setAuthenticatedUserAction, addOrReplaceUserAction, setUsersAction, deleteUserAction } = userSlice.actions;

export default userSlice.reducer;